<template >
	<div class="content">
		<van-nav-bar
			   title="散客票列表"
			   left-text=""
			   right-text="订单信息"
			  left-arrow
			  @click-left="onClickLeft"
			  @click-right="onClickRight"
			/>
		 <van-loading type="spinner" class='loading' color="#1989fa" />
		  <!-- vant空状态 -->
		<van-notice-bar color=""  left-icon="volume-o" >
			  {{headr}}
		</van-notice-bar>
		 <van-row  style="padding-bottom: 70px;" >
		 	<div>
		 	<van-row >
		 	  <van-col span="12" v-if="hide1">
				   	<span style="display: inline-block;height: 40px; width: 100%; text-align: center;color: black;
				   		font-size: 15px; line-height: 40px; background:darkturquoise;"
				   		@click="jc"
				   		>
				   		  散客计次票
				   	</span>
			   </van-col>
			    <van-col span="12" v-if="hide1">
			 		<span @click="js" style="display: inline-block;height: 40px;
			 			line-height: 40px; width: 100%; 
			 			background: azure;
			 			text-align: center;
			 			color: gainsboro;
			 			font-size: 15px;"
			 			>
			 			散客计时票
			 		</span>
			   	 </van-col>
			   	 <van-col span="12" v-if="hide2">
				   	<span style="display: inline-block;height: 40px;
			 			line-height: 40px; width: 100%; 
			 			background: azure;
			 			text-align: center;
			 			color: gainsboro;
			 			font-size: 15px;"
				   		@click="jc"
				   		>
				   		  散客计次票
				   	</span>
			   </van-col>
			    <van-col span="12" v-if="hide2">
			 		<span @click="js" 
			 			style="display: inline-block;height: 40px; width: 100%; text-align: center;color: black;
				   		font-size: 15px; line-height: 40px; background:darkturquoise;"
			 			>
			 			散客计时票
			 		</span>
			   	 </van-col>
		     </van-row>
	    	 </div>
			<div v-for="(item,index) in carts" :key="index" style="padding-top: 12px;" v-if="hide1">
				 <van-row >
				  	  <van-col span="24">
				  	  	   <van-col span="8">
				  	  	  	<el-image style="width: 80%; height: 100px; margin-left: 10%;" :src="item.thumb"></el-image>
				  	  	   </van-col>
				  	  	    <van-col span="16">
							   <van-col span="24" style="margin-top: 8px; padding-left: 10px;">{{item.title}}</van-col>
							   <van-col span="24" style="margin-top: 6px; font-size: 13px;padding-left: 10px;"> {{item.mode}}票</van-col>
							   <van-col span="12" style="margin-top: 15px; padding-left: 10px;">￥{{item.price}}.</van-col>
							   <van-col span="12" style="margin-top: 4px;">
							   	    <van-col span="8">
							   	    	<van-button   @click="jie(index)" :disabled="item.count===0" size="small" type="warning" icon="minus" ></van-button>
							   	    </van-col>
						   	  
							        <van-col span="6" style="margin-left: 8px; margin-top: 5px;">
							       		{{item.num}}
							        </van-col>
								    <van-col span="8">
								  		<van-button  @click="jia(index)" size="small" icon="plus"  type="primary"></van-button>
								    </van-col>
								</van-col>
					    		
						    </van-col>
					  </van-col>
			    </van-row>
	      </div>
	      <div v-for="(item,index) in carts_" :key="index" style="padding-top: 12px;" v-if="hide2">
				 <van-row >
				  	  <van-col span="24">
				  	  	   <van-col span="8">
				  	  	  	<el-image style="width: 80%; height: 100px; margin-left: 10%;" :src="item.thumb"></el-image>
				  	  	   </van-col>
				  	  	    <van-col span="16">
							   <van-col span="24" style="margin-top: 8px; padding-left: 10px;">{{item.title}}</van-col>
							   <van-col span="24" style="margin-top: 6px; font-size: 13px;padding-left: 10px;"> {{item.mode}}票</van-col>
							   <van-col span="12" style="margin-top: 15px; padding-left: 10px;">￥{{item.price}}.</van-col>
							   <van-col span="12" style="margin-top: 4px;">
							   	    <van-col span="8">
							   	    	<van-button   @click="jie_(index)" :disabled="item.count===0" size="small" type="warning" icon="minus" ></van-button>
							   	    </van-col>
						   	  
							        <van-col span="6" style="margin-left: 8px; margin-top: 5px;">
							       		{{item.num}}
							        </van-col>
								    <van-col span="8">
								  		<van-button  @click="jia_(index)" size="small" icon="plus"  type="primary"></van-button>
								    </van-col>
								</van-col>
					    		
						    </van-col>
					  </van-col>
			    </van-row>
	      </div>
		</van-row>
		<van-submit-bar  button-text="提交订单"   @submit="onSubmit" v-if="hide1">
		    <template >
		  	   <div id="numlist" >
		  	 	    <van-row >
				  	  <van-col span="24">
				  	  	 <van-col span="6" >
				  	 	    <span  class="xz" @click="xz()" style="margin-right: 10px;">预订须知</span>
				  	 	 </van-col>
				  	 	<van-col span="8">
				  	 	  <span style="margin-left:10px;">数量:{{numlist}}</span>
				  	 	   <span v-if="hide">{{numdata}}</span>
				  	    </van-col>
				  	       <van-col span="10">
				  	 	   <span class="total">合计:{{total}}</span>
				  	    </van-col>
	 	    	    </van-col>
			   </van-row>
	 		 </div>
		  </template>
		</van-submit-bar>
		<!-- vant提交订单栏 -->
		<van-submit-bar  button-text="提交订单"   @submit="onSubmit_" v-if="hide2">
		    <template >
		  	   <div id="numlist" >
		  	 	    <van-row >
				  	  <van-col span="24">
				  	  	 <van-col span="6" >
				  	 	    <span  class="xz" @click="xz()" style="margin-right: 10px;">预订须知</span>
				  	 	 </van-col>
				  	 	<van-col span="8">
				  	 	  <span style="margin-left:10px;">数量:{{numlist_}}</span>
				  	 	   <span v-if="hide">{{numdata_}}</span>
				  	    </van-col>
				  	       <van-col span="10">
				  	 	   <span class="total">合计:{{total_}}</span>
				  	    </van-col>
	 	    	    </van-col>
			   </van-row>
	 		 </div>
		  </template>
		</van-submit-bar>
	
		
		<!--<van-tabbar v-model="active">
		    <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router">购票首页</router-link></van-tabbar-item>
		    <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
	</div>
</template>

<script>
  export default {
  data () {
   		return{
   			hide2:false,
   			hide1:true,
   			hide:false,
   			carts:[], //添加到计次票
   			carts_:[], //添加到计时票
   			headr:'',
			xxid:"",
			jieshao:"",
			dizhi:"",
			yuding:"",
			tuigai:"",
			qupiao:"",
			numdata:'0',
			numdata_:'0',
		   }
    },
    mounted() {
    	this.ticketlist();
    	this.xxquery();
    },
  
	computed:{
		
	   total:function(){ //计算总价
				let total = 0
				 for(var i = 0;i<this.carts.length;i++){
		             var item = this.carts[i];
		             total += item.price * item.num
		         }
			    return total;
			},
		numlist:function(){
			var num = 0;
		         for(var i = 0;i<this.carts.length;i++){
		         	   var item = this.carts[i];
		               num += item.num;
		         }
		         this.numdata=num;
		         return num;
			},
	     total_:function(){ //计算总价
				let total = 0
				 for(var i = 0;i<this.carts_.length;i++){
		             var item = this.carts_[i];
		             total += item.price * item.num
		         }
				 
        	 return total;
			},
		 numlist_:function(){
			 var num_ = 0;
	         for(var i = 0;i<this.carts_.length;i++){
	         	   var item = this.carts_[i];
	               num_ += item.num;
	         }
	         this.numdata_=num_;
	         return num_;
			},
		},
	   methods:{
			jc(){
				console.log("11")
				this.hide1=true;
				this.hide2=false;
				this.ticketlist();
				this.numdata_='';
				this.numdata='';
				
			},
			js(){
				console.log("22")
				this.hide2=true;
				this.hide1=false;
				this.ticketlist_()
				this.numdata_='';
			    this.numdata='';
				
				
			},
			ticketlist(){
				let scenicAreaID = "";
				let isLoadThirdPlatform= 4;
				let ticketCateArray = [0] ;
				let ticketFeeMethoda = 0;
		        this.$axios({
		       // url: "/api/ticketType/select",
		         url: "/api/ticketType",
		        method: "get",
		        params: {
		          pageItems: 999, //每页显示的条数
		          pageNumber: 1, //页数
		          ticketCateArray:ticketCateArray,
		          scenicAreaID: scenicAreaID,
		          ticketFeeMethod:ticketFeeMethoda,
		          isLoadThirdPlatform:isLoadThirdPlatform
		        }
			      })
	        .then(res => {
	        	console.log(res.data)
	        	 var data = res.data[0];
	        	 this.carts = [];
			          for (const i in data) {
			          	 if (data[i].ticketFeeMethod == 0) {
			              var ticketFeeMethod = "计次";
			            } 
			            if (data[i].ticketFeeMethod == 1) {
			              var ticketFeeMethod = "计时";
			            } 
			             if (data[i].ticketFeeMethod == 2) {
			              var ticketFeeMethod = "按天数";
			            } 
		             var headPhoto = "";
		            if (data[i].photoPathLogo == ''){
		            	 headPhoto = "../../../../../static/upload.png"
		            }
		            else{
		               headPhoto = "/api/image?url=" + data[i].photoPathLogo;
		            }
		            this.carts.push({
		              id: data[i].id,
		              num:0,
		              title: data[i].ticketTypeName,
		              price : data[i].ticketPrice ,
		              thumb :headPhoto,
		              mode :ticketFeeMethod,
		             });
		          }
		         this.tableDataLength = res.data[1];
		        })
		        .catch(err => {
		          console.log(err);
		        });
         },
           ticketlist_(){
				
				let scenicAreaID = "";
				let isLoadThirdPlatform= 4;
				let ticketCateArray = [0] ;
				let ticketFeeMethoda = 1;
		        this.$axios({
		       // url: "/api/ticketType/select",
		         url: "/api/ticketType",
		        method: "get",
		        params: {
		          pageItems: 999, //每页显示的条数
		          pageNumber: 1, //页数
		          ticketCateArray:ticketCateArray,
		          scenicAreaID: scenicAreaID,
		          ticketFeeMethod:ticketFeeMethoda,
		          isLoadThirdPlatform:isLoadThirdPlatform
		        }
			      })
	        .then(res => {
	        	console.log(res.data)
	        	 var data = res.data[0];
	        	 this.carts_ = [];
			          for (const i in data) {
			          	 if (data[i].ticketFeeMethod == 0) {
			              var ticketFeeMethod = "计次";
			            } 
			            if (data[i].ticketFeeMethod == 1) {
			              var ticketFeeMethod = "计时";
			            } 
			             if (data[i].ticketFeeMethod == 2) {
			              var ticketFeeMethod = "按天数";
			            } 
		             var headPhoto = "";
		            if (data[i].photoPathLogo == ''){
		            	 headPhoto = "../../../../../static/upload.png"
		            }
		            else{
		               headPhoto = "/api/image?url=" + data[i].photoPathLogo;
		            }
		            this.carts_.push({
		              id: data[i].id,
		              num:0,
		              title: data[i].ticketTypeName,
		              price : data[i].ticketPrice ,
		              thumb :headPhoto,
		              mode :ticketFeeMethod,
		             });
		          }
		         this.tableDataLength = res.data[1];
		        })
		        .catch(err => {
		          console.log(err);
		        });
         },
			xxquery(){
			    let scenicAreaID = "";
				this.$axios({
						url: "/api/wechatPublicConfig",
						method: "get",
						params: {
							pageItems: 999, //每页显示的条数
							pageNumber: 1, //页数
							scenicAreaID: scenicAreaID,
							
						}
					})
				.then(res => {
					   var data = res.data[0];
					   this.headr=data[0].serviceTel;
					   this.xxid=data[0].id;
					   this.jieshao=data[0].scenicIntroduction;
				  	   this.dizhi =data[0].scenicAddress;
				  	   this.yuding =data[0].dueToThat;
				  	   this.tuigai =data[0].backToThat;
	 				   this.qupiao=data[0].takeTicketAddress;
					
				   
				})
				.catch(err => {
					console.log(err);
				});
		     },
			jia(index){
				this.carts[index].num++;
		     },
			jie(index){
				 if (this.carts[index].num === 0) return;
 					this.carts[index].num--;
			},
			jia_(index){
				this.carts_[index].num++;
		     },
			jie_(index){
				 if (this.carts_[index].num === 0) return;
 					this.carts_[index].num--;
			},
			onSubmit(){
				let numa =this.numdata;
				if(numa== 0){
						this.$notify({ type: 'warning', message: '请购票'});
						return;
				}
				/*if(numa>1){
						this.$notify({ type: 'warning', message: '每人每次只购一张票'});
						return;
				}*/
				
				let ticketlist=[];
			    var id ; var num;
		        for(var i = 0;i<this.carts.length;i++){
		            let item = this.carts[i];
		              id =item.id;
		              num =item.num;
		              if(num!==0){
		              	ticketlist.push({ticketTypeID:id,ticketCount:num})
		              }
		           
		 		}
		      let total =this.total;
			  let numlist =this.numlist;
			  let ticketArray=ticketlist;
			  let storage=window.sessionStorage;
    		  let openid = storage.getItem("openid")
			 
			  this.$router.push({ path: "/mn_ticketOrder",query: { total: total , numlist: numlist ,ticketArray:ticketArray}});
			},
			onSubmit_(){
				let numa =this.numdata_;
				if(numa== 0){
						this.$notify({ type: 'warning', message: '请购票'});
						return;
				}
				if(numa>1){
						this.$notify({ type: 'warning', message: '每人每次只购一张票'});
						return;
				}
				
				let ticketlist=[];
			    var id ; var num;
		        for(var i = 0;i<this.carts_.length;i++){
		            let item = this.carts_[i];
		              id =item.id;
		              num =item.num;
		              if(num!==0){
		              	ticketlist.push({ticketTypeID:id,ticketCount:num})
		              }
		           
		 		}
		      let total =this.total_;
			  let numlist =this.numlist_;
			  let ticketArray=ticketlist;
			  let storage=window.sessionStorage;
    		  let openid = storage.getItem("openid")
			 
			  this.$router.push({ path: "/mn_ticketOrder",query: { total: total , numlist: numlist ,ticketArray:ticketArray}});
			},
			onClickLeft(){
				this.$router.push({ path: "/mn_ticketIndex" });
			},
			onClickRight(){
				this.$router.push({ path: "/mn_ticketOrderlist" });
			},
			xz(){
				     /* this.xxid=data[0].id;
					   this.jieshao=data[0].scenicIntroduction;
				  	   this.dizhi =data[0].scenicAddress;
				  	   this.yuding =data[0].dueToThat;
				  	   this.tuigai =data[0].backToThat;
	 				   this.qupiao=data[0].takeTicketAddress;*/
	 			let text ="【景区介绍】:"+  this.jieshao  + "<br/>" + "【景区地址】:" + this.dizhi +"<br/>" +  "【取票地址】:"+this.qupiao +  "<br/>" + 
				       "【预订使用说明】:" +this.yuding+"<br/>" + 
				       "【退改说明】:"+this.tuigai;
				      
			    this.$dialog.alert({
			       message: text,
			       messageAlign:"left",
			    });

			},
		}

  
}
</script>

<style scoped>
	
	.card{
		font-size: 14px;
	}
	#last{
	  position: relative;
	  text-align: right;
	  padding-top: 20px;
	  margin-top: -60px;
	  margin-right: 20px;
	}
	#lastnum{
	   display: inline-block;
	   width: 40px;
	   height:30px;
	   line-height:30px;
	   font-size: 16px;
	   text-align: center;
	}
	#numlist span .button_{
	   display: inline-block;
	   width:40px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist span{
	   display: inline-block;
	   width:68px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist .total {
		text-align: left;
		 width:108px;
	}
	.xz{
		width:60px;
		height: 30px;
		background: #fffbe8;
		color: #ed6a0c !important;
	}
	.button_confirm{
		width:90%;
		margin-left: 5%;
		margin-top: 60px;
		background-color: #1171CD;
		border: 0px;
	}
	
	.router{
		color: #646566;
	}
	.activerouter{
		color: #1989fa;
	}
	.loading{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketList.vue